import { render, staticRenderFns } from "./PazarStandardHero.vue?vue&type=template&id=bef4e07e&scoped=true"
import script from "./PazarStandardHero.vue?vue&type=script&lang=js"
export * from "./PazarStandardHero.vue?vue&type=script&lang=js"
import style0 from "./PazarStandardHero.vue?vue&type=style&index=0&id=bef4e07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef4e07e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
